/**
 * The NavBar component at the top
 */
import React from 'react';
import {Nav, Navbar, NavItem} from "react-bootstrap";
import '../css/main-header-nav.css';

export default class MainHeaderNav extends React.Component {
  render() {
    return (
      <Navbar inverse collapseOnSelect className='main-header-nav hidden-xs'>
        <Navbar.Header>
          <Navbar.Brand>
            <img id="headerImg" src='/images/SprintRayLogo-White.png' />
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <MainNavBody/>
        </Navbar.Collapse>
      </Navbar>
    )
  }
}

export const MainNavBody = ({ className }) => (
  <Nav className={className} pullRight>
    <NavItem eventKey={1} href="http://sprintray.com">
      Back to SprintRay.com
    </NavItem>
    <NavItem eventKey={2} href="https://support.sprintray.com/hc/en-us">
      Support
    </NavItem>
    <NavItem eventKey={3} href="https://store.sprintray.com/">
      Store
    </NavItem>
  </Nav>
)


// WEBPACK FOOTER //
// ./src/components/main-header-nav.js